import React from 'react';
import GreyContainer from '../../../helpers/components/grey_container';
import { Col, Image, Row, Space } from 'antd';
import { Link } from 'react-router-dom';
import globalHelper from '../../../helpers/functions/global.helper';
import EntranceMotion from '../../../helpers/components/entrance_motion';
import { RightOutlined } from '@ant-design/icons';

const WhatToDoNextMyInvois = ({ticket}) => {
    const insuranceAddOn = ticket?.add_ons?.find((addOn) => addOn?.add_on_section?.is_insurance === true);
    const hasInsuranceAddOn = insuranceAddOn != null;
    const insuranceFormUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSfXeOsXIC-4Ahyl_0FZjh7KVimd3bSfGN4BzCUS5d2aCiFpOA/viewform';
    const cardPadding = 18;
    const cardTitleSize = 18;
    const mdSpan = hasInsuranceAddOn ? 8 : 12;
    return (
        <>
            <div style={{textAlign:'left'}}>
                <div style={{ marginTop : 24, }}>
                    <Row gutter={[20, 20]} justify={'center'}>
                        <Col xs={24} lg={22} xl={18}>
                            <Row gutter={[20, 20]} justify={'center'}>
                                <Col xs={24} md={mdSpan} lg={mdSpan}>
                                    <Link to={`/ticket/face/${ticket?.unique_no}${ticket?.salt ?? ''}?is_salt=1`}>
                                        <GreyContainer className="grey-card" height={"100%"} padding={0}>
                                            <div style={{width:'100%', display:'flex', flexDirection:'column', height:'100%'}}>
                                                <div style={{padding:cardPadding}}>
                                                    <div>
                                                        <div>
                                                            <Space style={{ color:'#4d4f5e' }}>
                                                                <div>
                                                                    <span style={{fontSize:cardTitleSize, fontWeight:'bold',}}>Upload Your Selfies</span>
                                                                </div>
                                                                <div>
                                                                    <RightOutlined className='right-arrow' />
                                                                </div>
                                                            </Space>

                                                            <div style={{ marginTop : 4, }}>
                                                                <span style={{fontWeight:500, color : 'var(--secondary-text-color)'}}>
                                                                    We use Facial AI for check-ins, remember to upload your selfies with the link provided in your email.
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='home-background' style={{textAlign:'center', overflow:'hidden', marginTop:'auto'}}>
                                                    <EntranceMotion>
                                                        <div style={{marginTop:12}}>
                                                            <Image className='features-image' src='/cibanners/selfie-guide.png' preview={false} style={{width: globalHelper?.isMobileScreen() ? 100 : 160}} />
                                                        </div>
                                                    </EntranceMotion>
                                                </div>
                                            </div>
                                        </GreyContainer>
                                    </Link>
                                </Col>

                                {/* E-Invoice */}
                                <Col xs={24} md={mdSpan} lg={mdSpan}>
                                    <Link to={`/myinvois/${ticket?.token}`}>
                                        <GreyContainer className="grey-card" height={"100%"} padding={0}>
                                            <div style={{width:'100%', display:'flex', flexDirection:'column', height:'100%'}}>
                                                <div style={{padding:cardPadding}}>
                                                    <div>
                                                        <div>
                                                            <Space style={{ color:'#4d4f5e' }}>
                                                                <div>
                                                                    <span style={{fontSize:cardTitleSize, fontWeight:'bold',}}>Request E-Invoice</span>
                                                                </div>
                                                                <div>
                                                                    <RightOutlined className='right-arrow' />
                                                                </div>
                                                            </Space>

                                                            <div style={{ marginTop : 4, }}>
                                                                <span style={{fontWeight:500, color : 'var(--secondary-text-color)'}}>
                                                                    Please request your e-invoice within 3 days from the invoice date.
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='brick-background' style={{textAlign:'center', overflow:'hidden', marginTop:'auto'}}>
                                                    <EntranceMotion>
                                                        <div style={{marginTop:12}}>
                                                            <Image className='features-image' src='/cibanners/document-submit.png' preview={false} style={{width: globalHelper?.isMobileScreen() ? 90 : 120}} />
                                                        </div>
                                                    </EntranceMotion>
                                                </div>
                                            </div>
                                        </GreyContainer>
                                    </Link>
                                </Col>

                                {/* Insurance */}
                                {
                                    hasInsuranceAddOn &&
                                    (
                                        <Col xs={24} md={mdSpan} lg={mdSpan}>
                                            <a href={insuranceFormUrl} target="_blank" rel="noreferrer noopener">
                                                <GreyContainer className="grey-card" height={"100%"} padding={0}>
                                                    <div style={{width:'100%', display:'flex', flexDirection:'column', height:'100%'}}>
                                                        <div style={{padding:cardPadding}}>
                                                            <div>
                                                                <div>
                                                                    <Space style={{ color:'#4d4f5e' }}>
                                                                        <div>
                                                                            <span style={{fontSize:cardTitleSize, fontWeight:'bold',}}>Purchased Insurance</span>
                                                                        </div>
                                                                        <div>
                                                                            <RightOutlined className='right-arrow' />
                                                                        </div>
                                                                    </Space>

                                                                    <div style={{ marginTop : 4, }}>
                                                                        <span style={{fontWeight:500, color : 'var(--secondary-text-color)'}}>
                                                                            Click to submit your Tune Protect insurance details.
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='home-background' style={{textAlign:'center', overflow:'hidden', marginTop:'auto'}}>
                                                            <EntranceMotion>
                                                                <div style={{marginTop:12}}>
                                                                    <Image
                                                                        className='features-image'
                                                                        src='/logo/tune_protect.png'
                                                                        preview={false}
                                                                        style={{width: globalHelper?.isMobileScreen() ? 90 : 120}}
                                                                    />
                                                                </div>
                                                            </EntranceMotion>
                                                        </div>
                                                    </div>
                                                </GreyContainer>
                                            </a>
                                        </Col>
                                    )
                                }
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
}

export default WhatToDoNextMyInvois;
